import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { toServerDuration, relativeToClocks, generateUUID } from '@datadog/browser-core';
import { RumEventType, RumLongTaskEntryType } from '../../rawRumEvent.types';
import { createPerformanceObservable, RumPerformanceEntryType, supportPerformanceTimingEvent } from '../../browser/performanceObservable';
export function startLongTaskCollection(lifeCycle, configuration) {
  var entryType = supportPerformanceTimingEvent(RumPerformanceEntryType.LONG_ANIMATION_FRAME) ? RumPerformanceEntryType.LONG_ANIMATION_FRAME : RumPerformanceEntryType.LONG_TASK;
  var subscription = createPerformanceObservable(configuration, {
    type: entryType,
    buffered: true
  }).subscribe(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        if (!configuration.trackLongTasks) {
          break;
        }
        var startClocks = relativeToClocks(entry.startTime);
        var rawRumEvent = processEntry(entry, startClocks);
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
          rawRumEvent: rawRumEvent,
          startClocks: startClocks,
          duration: entry.duration,
          domainContext: {
            performanceEntry: entry
          }
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}
function processEntry(entry, startClocks) {
  var id = generateUUID();
  var duration = toServerDuration(entry.duration);
  var baseEvent = {
    date: startClocks.timeStamp,
    type: RumEventType.LONG_TASK,
    _dd: {
      discarded: false
    }
  };
  if (entry.entryType === RumPerformanceEntryType.LONG_TASK) {
    return _objectSpread(_objectSpread({}, baseEvent), {}, {
      long_task: {
        id: id,
        entry_type: RumLongTaskEntryType.LONG_TASK,
        duration: duration
      }
    });
  }
  return _objectSpread(_objectSpread({}, baseEvent), {}, {
    long_task: {
      id: id,
      entry_type: RumLongTaskEntryType.LONG_ANIMATION_FRAME,
      duration: duration,
      blocking_duration: toServerDuration(entry.blockingDuration),
      first_ui_event_timestamp: toServerDuration(entry.firstUIEventTimestamp),
      render_start: toServerDuration(entry.renderStart),
      style_and_layout_start: toServerDuration(entry.styleAndLayoutStart),
      start_time: toServerDuration(entry.startTime),
      scripts: entry.scripts.map(function (script) {
        return {
          duration: toServerDuration(script.duration),
          pause_duration: toServerDuration(script.pauseDuration),
          forced_style_and_layout_duration: toServerDuration(script.forcedStyleAndLayoutDuration),
          start_time: toServerDuration(script.startTime),
          execution_start: toServerDuration(script.executionStart),
          source_url: script.sourceURL,
          source_function_name: script.sourceFunctionName,
          source_char_position: script.sourceCharPosition,
          invoker: script.invoker,
          invoker_type: script.invokerType,
          window_attribution: script.windowAttribution
        };
      })
    }
  });
}